export default __webpack_public_path__ + "assets/uv-index-7.05148bf1.svg";